module.exports = __webpack_public_path__ + "img/Openstreetmap_logo.5bb24548.png";